import React, { useEffect, useState } from "react";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import './UserLogs.css'

// Lucide Icons
import { Search, Clock, Monitor, Globe, Activity, Wifi, LogOut, Calendar, AlertCircle, Copy } from "lucide-react";

function AdminUserLogs({ adminType }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(false);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const handleSearch = async () => {
    try {
      if (searchMail) {
        let payload = {
          page: page,
          email: searchMail,
        };
        setLoader(true);
        const res = await api.getUserLogsAdmin(payload);
        if (res?.success) {
          setData(res?.logs);
          setnoOfUser(res.count);
          setLimit(res.limit);
          setLoader(false);
        } else {
          alert("Email does not exist");
          setLoader(false);
        }
      } else {
        alert("Please insert email for search");
      }
    } catch (error) {
      alert("Invalid Email Address");
      setLoader(false);
    }
  };

  useEffect(() => {
    if (searchMail) {
      handleSearch();
    }
  }, [page]);

  const handleCopyIP = (ip) => {
    navigator.clipboard.writeText(ip);
    alert('IP address copied to clipboard!');
  };

  return (
    <>
      <div className="user-logs-admin-container">
        <div className="user-logs-admin-content">
          <div className="user-logs-header-section">
            <div className="user-logs-header-main">
              <div className="user-logs-title-section">
                <h1 className="user-logs-page-title">
                  <Globe className="user-logs-title-icon" />
                  User Session Logs
                </h1>
                <p className="user-logs-page-subtitle">Track and manage user login sessions</p>
              </div>
              
              <div className="user-logs-search-compact">
                <div className="user-logs-search-wrapper">
                  <Search className="user-logs-search-icon" size={18} />
                  <input
                    type="email"
                    className="user-logs-search-input"
                    placeholder="Search by email..."
                    value={searchMail}
                    onChange={(e) => setSearchMail(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                  />
                  <button className="user-logs-search-button" onClick={handleSearch}>
                    Search
                  </button>
                </div>
              </div>
            </div>

            <div className="user-logs-stats-cards">
              <div className="user-logs-stat-card">
                <div className="user-logs-stat-icon-wrapper user-logs-stat-icon-1">
                  <Activity size={20} />
                </div>
                <div className="user-logs-stat-content">
                  <span className="user-logs-stat-label">Total Sessions</span>
                  <span className="user-logs-stat-value">{noOfUser}</span>
                </div>
              </div>
              
              <div className="user-logs-stat-card">
                <div className="user-logs-stat-icon-wrapper user-logs-stat-icon-2">
                  <Clock size={20} />
                </div>
                <div className="user-logs-stat-content">
                  <span className="user-logs-stat-label">Current Page</span>
                  <span className="user-logs-stat-value">{page}</span>
                </div>
              </div>
              
              <div className="user-logs-stat-card">
                <div className="user-logs-stat-icon-wrapper user-logs-stat-icon-3">
                  <Monitor size={20} />
                </div>
                <div className="user-logs-stat-content">
                  <span className="user-logs-stat-label">Active Sessions</span>
                  <span className="user-logs-stat-value">
                    {data.filter(item => item.status).length}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="user-logs-table-section">
            <div className="user-logs-table-container">
              <div className="user-logs-table-scroll">
                <UserLogsTable
                  data={data}
                  setPage={setPage}
                  page={page}
                  noOfUser={noOfUser}
                  limit={limit}
                  adminType={adminType}
                  onCopyIP={handleCopyIP}
                />
              </div>
              
              {data.length === 0 && !loader && (
                <div className="user-logs-empty-state">
                  <div className="user-logs-empty-icon">
                    <Monitor size={48} />
                  </div>
                  <h3>No Session Logs Found</h3>
                  <p>Search for a user's email to view their session history</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {loader && <Loader />}
      
    </>
  );
}

const UserLogsTable = ({ data, page, setPage, noOfUser, limit, adminType, onCopyIP }) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="user-logs-table-modern">
        <div className="user-logs-table-wrapper">
          <table className="user-logs-session-table">
            <thead>
              <tr>
                <th>
                  <div className="user-logs-header-cell">
                    <Wifi size={14} />
                    <span>Logged In IP</span>
                  </div>
                </th>
                <th>
                  <div className="user-logs-header-cell">
                    <Monitor size={14} />
                    <span>Device Name</span>
                  </div>
                </th>
                <th>
                  <div className="user-logs-header-cell">
                    <Clock size={14} />
                    <span>Start Time</span>
                  </div>
                </th>
                <th>
                  <div className="user-logs-header-cell">
                    <LogOut size={14} />
                    <span>End Time</span>
                  </div>
                </th>
                <th>
                  <div className="user-logs-header-cell">
                    <Activity size={14} />
                    <span>Status</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, key) => (
                <tr key={key} className="user-logs-session-row">
                  <td>
                    <div className="user-logs-cell-content">
                      {item.ipAddress ? (
                        <div className="user-logs-ip-address">
                          <span>{item.ipAddress}</span>
                          <button 
                            className="user-logs-copy-button"
                            onClick={() => onCopyIP(item.ipAddress)}
                            title="Copy IP address"
                          >
                            <Copy size={12} />
                          </button>
                        </div>
                      ) : (
                        <span className="user-logs-na-text">N/A</span>
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="user-logs-cell-content">
                      <div className="user-logs-device-name">{item.device || 'Unknown Device'}</div>
                    </div>
                  </td>
                  <td>
                    <div className="user-logs-cell-content">
                      <div className="user-logs-date-time">
                        <Calendar size={12} className="user-logs-date-icon" />
                        {formatDate(item?.createdAt)}
                      </div>
                    </div>
                  </td>
                  <td>
                    <div className="user-logs-cell-content">
                      {item.status ? (
                        <div className="user-logs-ongoing-session">
                          <div className="user-logs-pulse-dot"></div>
                          On-going Session
                        </div>
                      ) : (
                        <div className="user-logs-date-time">
                          <Calendar size={12} className="user-logs-date-icon" />
                          {formatDate(item?.updatedAt)}
                        </div>
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="user-logs-cell-content">
                      {item.status ? (
                        <div className="user-logs-status-badge user-logs-status-active">
                          <div className="user-logs-status-dot"></div>
                          Active
                        </div>
                      ) : (
                        <div className="user-logs-status-badge user-logs-status-ended">
                          <div className="user-logs-status-dot"></div>
                          Ended
                        </div>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {noOfUser > 0 && (
          <div className="user-logs-table-footer">
            <div className="user-logs-pagination-info">
              Showing page {page} of {Math.ceil(noOfUser / limit)}
            </div>
            <div className="user-logs-pagination-container">
              <Stack spacing={2}>
                <Pagination
                  count={Math.ceil(noOfUser / limit)}
                  page={page}
                  onChange={handleChange}
                  shape="rounded"
                  color="primary"
                  size="medium"
                />
              </Stack>
            </div>
          </div>
        )}
      </div>

    </>
  );
};

export default AdminUserLogs;